export default __webpack_public_path__ + "136fb032ed3dbba3430ef47316cfa8ab.png";